var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h1', [_vm._v("포인트 사용")]), _c('section', {
    staticClass: "mt-4"
  }, [_vm._m(0), _vm._m(1), _vm._m(2), _vm._m(3), _vm._m(4), _c('prism-editor', {
    staticClass: "rounded",
    attrs: {
      "line-numbers": ""
    },
    model: {
      value: _vm.section1.exampleCode,
      callback: function callback($$v) {
        _vm.$set(_vm.section1, "exampleCode", $$v);
      },
      expression: "section1.exampleCode"
    }
  })], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('b', [_vm._v("* 개발자에게 제공되는 예제입니다.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_vm._v("트랜잭션 형태로 기능이 제공됩니다. 포인트 차감이 필요한 "), _c('b', [_vm._v("시스템 로직")]), _vm._v("에 추가해주시면 됩니다.")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b', [_vm._v("1. transaction.use()")]), _c('p', [_vm._v("회원정보, 사용금액, 로그를 파라미터로 전달합니다."), _c('br'), _vm._v("임시차감을 시도하며 보유포인트가 부족시 throw 예외를 발생시킵니다.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b', [_vm._v("2. transaction.commit()")]), _c('p', [_vm._v("다른작업 후 문제사항이 없다면, 포인트 변동을 확정하고 히스토리를 기록합니다.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b', [_vm._v("3. transaction.rollback()")]), _c('p', [_vm._v("문제가 발생한경우 포인트를 원래상태로 복구하고, 해당 내용을 확정하지 않습니다.")])]);
}]

export { render, staticRenderFns }